import { ChatData } from '@data-access/talk-desk';
import { createAction, props } from '@ngrx/store';

const initialize = createAction('[Talk Desk] Initialize');
const initializeSuccess = createAction('[Talk Desk] Initialize Success');
const initializeFailure = createAction(
  '[Talk Desk] Initialize Failure',
  props<{ error: string }>(),
);

const toggleChatVisibility = createAction(
  '[Talk Desk] Toggle Chat Visibility',
  props<{ chatId: string }>(),
);

const openChat = createAction(
  '[Talk Desk] Open Chat',
  props<{ chatId: string; chatData: ChatData }>(),
);

const closeChat = createAction(
  '[Talk Desk] Close Chat',
  props<{ chatId: string }>(),
);

const setContext = createAction(
  '[Talk Desk] Set Context',
  props<{ chatId: string; chatData: ChatData }>(),
);

const closeAllChats = createAction('[Talk Desk] Close All Chats');

const setActiveChat = createAction(
  '[Talk Desk] Set Active Chat',
  props<{ chatId: string }>(),
);

export const TALKDESK_ACTIONS = {
  initialize,
  initializeSuccess,
  initializeFailure,
  toggleChatVisibility,
  openChat,
  closeChat,
  closeAllChats,
  setActiveChat,
  setContext,
};
